export default __webpack_public_path__ + "static/media/tutorial_privileges.0c15268e.png";